<svg xmlns="http://www.w3.org/2000/svg" width="13" height="3" viewBox="0 0 13 3">
  <g id="points" transform="translate(-544.331 -1570)">
    <g id="Groupe_3946" data-name="Groupe 3946" transform="translate(-239.669 48)">
      <circle id="Ellipse_100" data-name="Ellipse 100" cx="1.5" cy="1.5" r="1.5" transform="translate(784 1522)" fill="#3c3c3b"/>
      <circle id="Ellipse_101" data-name="Ellipse 101" cx="1.5" cy="1.5" r="1.5" transform="translate(789 1522)" fill="#3c3c3b"/>
      <circle id="Ellipse_102" data-name="Ellipse 102" cx="1.5" cy="1.5" r="1.5" transform="translate(794 1522)" fill="#3c3c3b"/>
    </g>
  </g>
</svg>
